import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../auth';
import { SidebarComponent } from '../../components';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import {
    TabsHistoryMeetingDark,
    TabsHistoryMeetingLight,
    TabsRequestMeetingDark,
    TabsRequestMeetingLight,
    TabsTodaysMeetingDark,
    TabsTodaysMeetingLight
} from '../../components/TabsComponent';
import axios from '../../api/axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import RingLoader from 'react-spinners/RingLoader';

function Meeting() {
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const { tokens, showSidebar } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [listRequestMeeting, setListRequestMeeting] = useState([]);
    const [listTodayMeeting, setListTodayMeeting] = useState([]);
    const [listHistoryMeeting, setListHistoryMeeting] = useState([]);
    const [listUser, setListUser] = useState([]);
    const [loading, setLoading] = useState(true);
    const tokenUser = tokens?.token;
    const navigate = useNavigate();

    const retrieveMeeting = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/manage/requests/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                const filterDataRequest = res.data.filter(item => item.status === "processing");
                setListRequestMeeting(filterDataRequest);

                const filterDataToday = res.data.filter(item => item.status === "approved" && item.finished === false);
                setListTodayMeeting(filterDataToday);

                const filterDataHistory = res.data.filter(item => {
                    return (item.status === "approved" || item.status === "denied") && item.finished === true;
                });
                setListHistoryMeeting(filterDataHistory)

                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);

                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });
                    } else {
                        console.error(err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Gagal memuat data pada server!',
                        });
                    }
                }, delay);
            })
    };

    // console.log(listHistoryMeeting)


    const retrieveUser = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/account/users/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setListUser(res.data);
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);

                setTimeout(() => {
                    setLoading(false);
                    console.error(err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Gagal memuat data pada server!',
                    });
                }, delay);
            })
    };

    useEffect(() => {
        if (tokenUser !== undefined) retrieveMeeting()
        if (tokenUser !== undefined) retrieveUser()
    }, [tokenUser]);

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            {loading && (
                <div id={theme === 'light' ? 'loading-overlay-dark' : 'loading-overlay-light'}>
                    <RingLoader
                        size={80}
                        color={theme === 'light' ? '#D2DC02' : '#10B1AA'}
                    />
                </div>
            )}
            {!loading && (
                <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                    style={{
                        width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '80px' : '210px'})`,
                        marginLeft: isMobile ? '0px' : showSidebar ? '80px' : '210px',
                        transition: '0.8s'
                    }}
                >
                    <div className={isMobile ? '' : 'ms-3'}>
                        <Row>
                            <Col xs={12} lg={6} className='text-start'>
                                <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '28px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                    Daftar Meeting
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div className={isMobile ? 'pt-4' : 'mx-3 pt-4'}>
                        <Tabs
                            id="controlled-tab-meeting"
                            defaultActiveKey="request"
                            fill
                            style={{ fontFamily: 'Poppins-Regular' }}
                        >
                            <Tab eventKey="request" title="Permintaan">
                                {
                                    theme === 'light' ?
                                        <TabsRequestMeetingDark
                                            listRequestMeeting={listRequestMeeting}
                                            listUser={listUser}
                                        />
                                        :
                                        <TabsRequestMeetingLight
                                            listRequestMeeting={listRequestMeeting}
                                            listUser={listUser}
                                        />
                                }
                            </Tab>
                            <Tab eventKey="meeting" title="Jadwal">
                                {
                                    theme === 'light' ?
                                        <TabsTodaysMeetingDark
                                            listTodayMeeting={listTodayMeeting}
                                            listUser={listUser}
                                        />
                                        :
                                        <TabsTodaysMeetingLight
                                            listTodayMeeting={listTodayMeeting}
                                            listUser={listUser}
                                        />
                                }
                            </Tab>
                            <Tab eventKey="history" title="Riwayat">
                                {
                                    theme === 'light' ?
                                        <TabsHistoryMeetingDark
                                            listHistoryMeeting={listHistoryMeeting}
                                            listUser={listUser}
                                        />
                                        :
                                        <TabsHistoryMeetingLight
                                            listHistoryMeeting={listHistoryMeeting}
                                            listUser={listUser}
                                        />
                                }
                            </Tab>
                        </Tabs>
                        <br />
                        <br />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Meeting
